import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const fetchProducts = async () => (await api.get("/products")).data;
export const fetchProduct = async (slug, config = {}) => (await api.get(`/products/${slug}`, config)).data;
export const createOrder = async (payload) => (await api.post("/orders", payload)).data;
export const fetchOrder = async (orderNumber) => (await api.get(`/orders/${orderNumber}`)).data;
export const fetchOrders = async () => (await api.get("/orders")).data;
export const updateOrderStatus = async (orderNumber, status) =>
    (await api.patch(`/orders/${orderNumber}/status`, { status })).data;
export const updateProduct = async (productId, payload) =>
    (await api.patch(`/products/${productId}`, payload)).data;
export const subscribeNewsletter = async (email) =>
    (await api.post("/newsletter", { email })).data;
